import { EntityTypeEnum } from "@scrinz/dtos";
export function entityCanHaveChildren(entity) {
    return (entity.type === EntityTypeEnum.System ||
        entity.type === EntityTypeEnum.Organization ||
        entity.type === EntityTypeEnum.Group);
}
//# sourceMappingURL=entity-can-have-children.js.map